const BASE_URL = "https://api.orvelinfastigheter.se";

export const prefixImageUrl = (url, version = false) => {
  if (!url) {
    return null;
  }
  // Check if the URL is already absolute
  if (url.startsWith("http://") || url.startsWith("https://")) {
    return url;
  }
  // Assume it's a relative path from the domain root
  if ( version ) {
    const imageName = url.replace("/media/", "").split(".")[0];
    return `${BASE_URL}/media/_versions/${imageName}_${version}.${url.split(".")[1]}`;
  }
  return `${BASE_URL}${url.startsWith("/") ? url : "/" + url}`;
}; 